exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width:1024px){.wrap-popup[data-v-35322bd3]{width:calc(100% - 286px);margin-left:calc(50% - 286px)}}@media screen and (max-width:1024px) and (min-width:769px){.wrap-popup[data-v-35322bd3]{width:calc(100% - 345px);margin-left:calc(50% - 195px)}}@media screen and (max-width:768px) and (min-width:426px){.wrap-popup[data-v-35322bd3]{width:calc(100% - 286px);margin-left:calc(50% - 195px)}}.setting-profile-wrapper[data-v-35322bd3]{margin-top:40%}", ""]);

// exports
